import { render, staticRenderFns } from "./Uncomplete.vue?vue&type=template&id=6cf268e4&scoped=true&"
import script from "./Uncomplete.vue?vue&type=script&lang=js&"
export * from "./Uncomplete.vue?vue&type=script&lang=js&"
import style0 from "./Uncomplete.vue?vue&type=style&index=0&id=6cf268e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf268e4",
  null
  
)

export default component.exports